import React from "react";

import "./CardView.scss"

const CardView = ({ children, className}) => {
    return <div className={`CardView ${className}`}>{children}</div>;
};

export default CardView;
